import { Action, CustomTagType, DockType, ErrorCodes, OperationType, Position, WindowType } from "puzzle";
import SupplementaryFilesUpload from "../../components/Drawer/Tabs/SupplementaryFiles/SupplementaryFilesUpload";

export const openSupplementaryUploadDialog: Action = [{
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionId: '{selectedSubmissions[0].submissionId}',
        submissionName: '{selectedSubmissions[0].submissionName}',
        projectId: '{selectedSubmissions[0].projectId}',
        taskId: '{selectedSubmissions[0].taskId}'
      }
    }
  },
  type: OperationType.data
}, {
  persistent: ['urlLoadData', 'urlUpload'],
  type: OperationType.addPersistentData
}, {
  children: [{
    render: SupplementaryFilesUpload,
    propArgs: ['submissionId', 'projectId', 'filesToUpload', 'languages', 'taskId', 'urlLoadData', 'urlUpload', 'userType']
  }],
  className: 'md supplementary-upload',
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'supplementaryFilesUpload.cancel',
    operations: [{
      dispatcherIds: ['AsyncUploadDispatcher'],
      type: OperationType.unlink
    }],
    btnConfig: {
      pos: Position.end
    }
  }, {
    btnName: 'supplementaryFilesUpload.save',
    operations: [{
      actionType: {
        dispatcherId: 'mainDispatcher'
      },
      name: 'supplementaryUploadDialogSaveHandler',
      type: OperationType.action
    }],
    close: false,
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  title: 'supplementaryFilesUpload.title',
  type: OperationType.dialog
}]

export const supplementaryUploadDialogSaveHandler: Action = [{
  moduleName: 'DropUpload',
  name: 'getData',
  mappingName: 'supplementaryFilesData',
  type: OperationType.addOperationData
}, {
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        url: `{urlUpload}`,
        params: '{supplementaryFilesData.params}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        url: `{urlUpload}`,
        userType: `{userType}`
      },
      afterPingFinishAction: 'afterSupplementaryFilesSave',
      method: 'post'
    }
  },
  type: OperationType.data
}, {
  name: 'pingingRequest',
  type: OperationType.action
}];

export const afterSupplementaryFilesSave: Action = [{
  condition: '{responseData.rejectedFiles} && {responseData.rejectedFiles.length}',
  conditionOperations: [{
    moduleName: 'SupplementaryFiles',
    args: ['responseData'],
    name: 'updateRejectedFiles',
    mappingName: 'group',
    type: OperationType.addOperationData
  }, {
    name: 'rejectedSupplementaryFiles',
    type: OperationType.action
  }],
  elseOperations: [{
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}, {
  condition: '{userType} !== "ORGANIZATION" ',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          submissionId: '{selectedSubmissions[0].taskId}',
          url: '{urlLoadData}'
        }
      }
    },
    name: 'getSupplementaryFilesData',
    type: OperationType.action
  }], elseOperations: [
    {
      data: {
        template: {
          bind: {
            submissionId: '{selectedSubmissions[0].submissionId}',
            url: `{urlLoadData}`
          }
        }
      },
      name: 'getSupplementaryFilesData',
      type: OperationType.action
    }],
  type: OperationType.conditional
}, {
  name: 'refreshMainGrid',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];